import store from '@/store/index.js';

export const publicPages = [
  'login',
  'request_password',
  'google_oauth_handling',
  'info_undergraduate',
  'info_graduate',
  'list_undergraduate',
  'list_graduate',
  'index',
];

export const userPages = [
  'authen',
];

export const preStudentPages = [
  'main',
  'page1',
  'page2',
  'page31',
  'page4',
  'page5',
  'page6',
  'page7',
  'page8',
  'page9',
  'kmitl1',
  'questionnaire',
];

export const preXStudentPages = [
  'main',
  'page1',
  'page2',
  'page32',
  'page4',
  'page5',
  'page6',
  'page7',
  'page8',
  'page9',
  'kmitl1',
  'questionnaire',
];

export const studentPages = [
  'main_menu',
  'kmitl1',
];

export const xStudentPages = [
  'main_menu',
  'kmitl1',
];

export const adminPages = [
  'main_menu',
  'config_year',
  'config_round',
  'config_document',
  'main_officer',
  'kmitl1',
  'find_edit',
  'import_data',
  'generate_studentID',
  'export_data',
];

export const registrarOfficerPages = [
  'main_menu',
  'config_year',
  'config_round',
  'config_document',
  'main_officer',
  'kmitl1',
  'find_edit',
  'import_data',
  'generate_studentID',
  'export_data',
];

export const facultyOfficerPages = [
  'main_menu',
  'kmitl1',
];

export const teacherPages = [
  'main_menu',
  'kmitl1',
];

export function check_permission([route_name]) {
  // Public
  if (publicPages.some(page => route_name.includes(page))) {
    return true;
  }

  // User
  else if (
    userPages.some(page => route_name.includes(page)) &&
    store.state.user.is_authen
  ) {
    return true;
  }

  // Pre Student
  else if (
    preStudentPages.some(page => route_name.includes(page)) &&
    store.state.user.is_authen &&
    store.state.user.surrogated_student_info &&
    store.state.user.surrogated_student_info.payload.ticket.privilege == 1
  ) {
    return true;
  }

  // Pre X Student
  else if (
    preXStudentPages.some(page => route_name.includes(page)) &&
    store.state.user.is_authen &&
    store.state.user.surrogated_student_info &&
    store.state.user.surrogated_student_info.payload.ticket.privilege == 2
  ) {
    return true;
  }


  // Student
  else if (
    studentPages.some(page => route_name.includes(page)) &&
    store.state.user.is_authen &&
    store.state.user.surrogated_student_info &&
    store.state.user.surrogated_student_info.payload.ticket.privilege == 80
  ) {
    return true;
  }

  // XStudent
  else if (
    xStudentPages.some(page => route_name.includes(page)) &&
    store.state.user.is_authen &&
    store.state.user.surrogated_student_info &&
    (
      store.state.user.surrogated_student_info.payload.ticket.privilege == 85 ||
      store.state.user.is_future_innovation_student
    )
  ) {
    return true;
  }

  // Admin
  else if (
    adminPages.some(page => route_name.includes(page)) &&
    store.state.user.is_authen &&
    store.state.user.user_info.payload.ticket.privilege == 91
  ) {
    return true;
  }

  // Registrar Officer
  else if (
    registrarOfficerPages.some(page => route_name.includes(page)) &&
    store.state.user.is_authen &&
    (store.state.user.user_info.payload.ticket.privilege == 40 || store.state.user.user_info.payload.ticket.privilege == 45)
  ) {
    return true;
  }

  // Faculty Officer
  else if (
    facultyOfficerPages.some(page => route_name.includes(page)) &&
    store.state.user.is_authen &&
    (
      store.state.user.user_info.payload.ticket.privilege == 10 ||
      store.state.user.user_info.payload.ticket.privilege == 19 ||
      store.state.user.user_info.payload.ticket.privilege == 35 ||
      store.state.user.user_info.payload.ticket.privilege == 55
    )
  ) {
    return true;
  }

  // Teacher
  else if (
    teacherPages.some(page => route_name.includes(page)) &&
    store.state.user.is_authen &&
    store.state.user.user_info.payload.ticket.privilege == 60
  ) {
    return true;
  }

  else {
    return false;
  }
}